export default "__VITE_ASSET__IFlgbp2g__"